import { erpAxios } from '..';

const getCRKDocumentsData = async (id) => {
  const { data } = await erpAxios.get(`/crkKrediti/data/${id}`);
  return data;
};

export default getCRKDocumentsData;